import React from 'react';
import { PLUGIN_TOOLBAR_BUTTON_ID, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { getVisibleOnlyOnDesktopResolver } from 'wix-rich-content-plugin-commons';
import { SizePanel, NodeSizeButton, AlignmentPanel, NodeAlignmentButton } from 'wix-rich-content-toolbars-ui';
import { GIF_BUTTONS, gifModals } from './constants.js';
import GiphyInsertModal from './modals/InsertModal.js';
import 'wix-rich-content-common';
import 'ricos-content/libs/convertBlockDataToRicos';
import 'ricos-context';
import './giphyApiInputModal-6c59604a.js';
import 'classnames';
import 'lodash';
import 'wix-rich-content-ui-components';
import './style-inject.es-e7b07dd7.js';
import './dataHooks.js';
import './toolbar/giphySelector.js';
import 'react-custom-scrollbars';
import 'react-infinite-scroller';
import './giphyEmptyState-54759bf5.js';
import './toolbar/getGiphyProxyUrl.js';
import './icons/PoweredByGiphy.js';
import './types.js';

const getToolbarButtons = (config, services) => {
  const {
    context: { isMobile }
  } = services;
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      modal: {
        Component: decorateComponentWithProps(SizePanel, {
          options: [
            "SMALL",
            "CONTENT",
            "FULL_WIDTH",
            "ORIGINAL"
          ]
        }),
        id: GIF_BUTTONS.size
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeSizeButton, { id: GIF_BUTTONS.size, toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: GIF_BUTTONS.alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: GIF_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      modal: {
        Component: decorateComponentWithProps(GiphyInsertModal, {
          modalId: gifModals.replace,
          getGiphyUrl: config == null ? void 0 : config.getGiphyUrl
        }),
        id: gifModals.replace
      },
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode } }) => {
        const { modals } = services;
        if (modals == null ? void 0 : modals.isModalOpen(gifModals.replace)) {
          modals.closeModal(gifModals.replace);
        } else {
          modals == null ? void 0 : modals.openModal(gifModals.replace, {
            componentProps: {
              componentData: selectedNode.attrs,
              //TODO: convert to draft
              nodeId: selectedNode.attrs.id
            },
            positioning: { placement: "bottom", referenceElement },
            layout: isMobile2 ? "fullscreen" : "popover"
          });
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};

export { getToolbarButtons };
//# sourceMappingURL=getToolbarButtons.js.map
